import React, { useState, useEffect } from "react";
import { getAPIURL, getVendorID, getVendorSettings } from "../../services/helper";
import http from "../../services/http";
import DataTable from "react-data-table-component";
import { Spinner, Container, Card, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { openView } from "../../ReduxToolkit/Reducers/viewReducer";

const StockZeroReport = ({ backTo }) => {
  const api_url = getAPIURL();
  const vendor_id = getVendorID();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStockZeroReport();
  }, []);

  const printReport = () => {
    const vendor_email = getVendorSettings("email");
    const vendor_store_name = getVendorSettings("name");
    const vendor_address = getVendorSettings("vendor_contact_address");
    const vendor_phone = getVendorSettings("vendor_contact_phone");
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Stock Zero Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 20px; }
            .header h2 { margin: 0; }
            .header p { margin: 0; }
            .header h3 { margin-top: 20px; margin-bottom: 10px; }
            .header hr { margin-top: 10px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .summary { margin-bottom: 20px; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>${vendor_store_name}</h2>
            <p>${vendor_address}</p>
            <p>${vendor_phone} | ${vendor_email}</p>
            <h3>Stock Zero Report</h3>
            <hr>
          </div>
          <div class="summary">
            <p><strong>Total Out of Stock Products:</strong> ${data.length}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Product ID</th>
                <th>Product Name</th>
                <th>SKU</th>
                <th>Stock Status</th>
              </tr>
            </thead>
            <tbody>
              ${data.map(item => `
                <tr>
                  <td>${item.product_id}</td>
                  <td>${item.product_name}</td>
                  <td>${item.sku || 'N/A'}</td>
                  <td>Out of Stock</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const fetchStockZeroReport = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ vendor_id });
      const { data } = await http.get(
        `${api_url}/reports/stock-zero?${params.toString()}`
      );
      setData(data);
    } catch (error) {
      console.error("Error fetching stock zero report:", error);
    }
    setLoading(false);
  };

  const columns = [
    { name: "Product ID", selector: (row) => row.product_id, sortable: true },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
    },
    { name: "SKU", selector: (row) => row.sku || "N/A", sortable: true },
    { name: "Stock Status", selector: () => "Out of Stock", sortable: true },
  ];

  return (
    <div className="page-body">
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          {backTo && (
            <Button color="primary" onClick={() => dispatch(openView(backTo))}>
              Back
            </Button>
          )}
          <h2 className="text-center flex-grow-1 text-danger">Stock Zero Report</h2>
          <div></div>
        </div>

        {/* Stock Zero Data Table */}
        {loading ? (
          <div className="text-center">
            <Spinner color="danger" size="lg" />
            <p>Loading Out of Stock Products...</p>
          </div>
        ) : (
          <Card className="p-3 shadow-sm">
            <h4 className="mb-3">Out of Stock Products ({data.length})</h4>
            <DataTable
              columns={columns}
              data={data}
              pagination
              striped
              highlightOnHover
            />
          </Card>
        )}
        
        <div className="text-center mt-4 mb-4">
          <Button color="success" onClick={printReport}>
            Print Report
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default StockZeroReport;
